import React from 'react';
import CONSTANTS from '../../config/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/pro-regular-svg-icons';
import moment from 'moment';
import find from 'lodash/find';

const BirthdayBlock = (props) => {
    const { contentFields, width, relatedContents } = props;

    const getContentFieldValue = (fieldDefinitionKey) => {
        const data = find(contentFields, { fieldDefinitionKey });

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }

        return false
    };

    const getBlockWidth = () => {
        let w = 60;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            const widthValue = getContentFieldValue('Width');
            if (widthValue && widthValue !== CONSTANTS.BLOCK_DEFAULT_WIDTH && widthValue !== w) {
                w = widthValue;
            }
        }

        return w;
    };

    const items = relatedContents.map(item => item);

    return (
        <section className={"birthdays w--" + getBlockWidth() + " show--shadow"}>
            <section className="birthdays--inner">
                <div className="upcoming-birthdays">
                    <h3>
                        <span><FontAwesomeIcon icon={faGift} /></span>
                        <em>{getContentFieldValue('Title')}</em>
                    </h3>
                    {items &&
                        <ul>
                            {items.map((bday, key) => {
                                if (key > 8) return null;

                                return (
                                    <li key={key}>
                                        <span>{bday.firstName} {bday.lastName}</span>
                                        <em className="date">{moment(bday.birthday).format("D/M/Y")}</em>
                                    </li>
                                );
                            })}
                        </ul>
                    }
                </div>
            </section>
        </section>
    );
};

export default BirthdayBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/BirthdayBlock.js